/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Upload_CompleteInputs */

const en_toast_upload_complete = /** @type {(inputs: Toast_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Complete`)
};

const es_toast_upload_complete = /** @type {(inputs: Toast_Upload_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subida completada`)
};

/**
* | output |
* | --- |
* | "Upload Complete" |
*
* @param {Toast_Upload_CompleteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_upload_complete = /** @type {((inputs?: Toast_Upload_CompleteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Upload_CompleteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_upload_complete(inputs)
	return en_toast_upload_complete(inputs)
});